import { AppBar, Typography } from '@mui/material';
import styled from 'styled-components';

export const HeaderWrapper = styled(AppBar)`
  && {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    background: none;
    box-shadow: none;
    margin-top: 1.25rem;
    margin-bottom: 1.5rem;
  }
`;

export const PageTitle = styled(Typography)`
  && {
    flex-grow: 1;
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
